import actions from './actions';

const initState = {
  pageLoading: false,
  isError: false,
  errorMessage: false,

  activeSettlementRequest: null,
  activeSettlementRequestLoading: false,
  activeSettlementRequestIsError: false,
  activeSettlementRequestErrorMessage: false,

  activeSettlementPaymentChannels: null,
  activeSettlementPaymentChannelsLoading: false,
  activeSettlementPaymentChannelsIsError: false,
  activeSettlementPaymentChannelsErrorMessage: false,

  settlementReportHistoryLoading: false,
  settlementReportHistoryData: null,
  settlementReportHistoryIsError: false,
  settlementReportHistoryPagination: null,
  settlementReportHistoryLoadMore: false,

  presignedUrlsAddendum: null,

  generatedSettlementReportLoading: false,
  generatedSettlementReportIsError: false,

  settlementSubmissionsLoading: false,
  settlementSubmissions: null,
  settlementSubmissionsIsError: false,
  settlementSubmissionsPagination: null,
  settlementSubmissionsLoadMore: false,
  settlementSubmissionsSummary: null,

  settlementSubmissionLoading: false,
  settlementSubmission: null,
  settlementSubmissionIsError: false,

  downloadSettlementSubmissionDocumentLoading: false,
  downloadSettlementSubmissionDocumentIsError: false,

  consolidatedSettlementReportsLoading: false,
  consolidatedSettlementReportsIsError: false,
  consolidatedSettlementReports: null,
  consolidatedSettlementReportsPagination: false,

  downloadConsolidatedSettlementReportLoading: false,
  downloadConsolidatedSettlementReportLoadingIsError: null,

  merchantSettlementSummaryReportsLoading: false,
  merchantSettlementSummaryReports: null,
  merchantSettlementSummaryReportsIsError: false,
  merchantSettlementSummaryReportsPagination: false,
  merchantSettlementSummaryReportsFilter: null
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.CLEAR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
        isError: false
      };

    case actions.FETCHING_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID:
      return {
        ...state,
        activeSettlementRequest: null,
        activeSettlementRequestLoading: action.loading,
        activeSettlementRequestIsError: false
      };

    case actions.FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID_SUCCESS:
      return {
        ...state,
        activeSettlementRequest: action.result,
        activeSettlementRequestLoading: action.loading,
        activeSettlementRequestIsError: false
      };

    case actions.FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID_FAILED:
      return {
        ...state,
        activeSettlementRequest: null,
        activeSettlementRequestLoading: action.loading,
        activeSettlementRequestIsError: true
      };

    case actions.FETCHING_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID:
      return {
        ...state,
        activeSettlementPaymentChannels: null,
        activeSettlementPaymentChannelsLoading: action.loading,
        activeSettlementPaymentChannelsIsError: false
      };

    case actions.FETCH_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID_SUCCESS:
      return {
        ...state,
        activeSettlementPaymentChannels: action.result,
        activeSettlementPaymentChannelsLoading: action.loading,
        activeSettlementPaymentChannelsIsError: false
      };

    case actions.FETCH_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID_FAILED:
      return {
        ...state,
        activeSettlementPaymentChannels: null,
        activeSettlementPaymentChannelsLoading: action.loading,
        activeSettlementPaymentChannelsIsError: true
      };

    case actions.FETCHING_SETTLEMENT_REPORT_HISTORY:
      return {
        ...state,
        settlementReportHistoryLoading: action.loading
      };

    case actions.FETCH_SETTLEMENT_REPORT_HISTORY_SUCCESS:
      return {
        ...state,
        settlementReportHistoryLoading: action.loading,
        settlementReportHistoryData: action.result,
        settlementReportHistoryIsError: false,
        settlementReportHistoryPagination: action.pagination,
        settlementReportHistoryLoadMore: false
      };

    case actions.LOADING_MORE_SETTLEMENT_REPORT_HISTORY:
      return {
        ...state,
        settlementReportHistoryLoadMore: true
      };

    case actions.FETCH_SETTLEMENT_REPORT_HISTORY_FAILED:
      return {
        ...state,
        settlementReportHistoryLoading: action.loading,
        settlementReportHistoryData: action.result,
        settlementReportHistoryIsError: true,
        settlementReportHistoryPagination: action.pagination,
        settlementReportHistoryLoadMore: false
      };
    case actions.RESET_SETTLEMENT_REPORT_HISTORY:
      return {
        ...state,
        settlementReportHistoryLoading: false,
        settlementReportHistoryData: null,
        settlementReportHistoryIsError: false,
        settlementReportHistoryPagination: null,
        settlementReportHistoryLoadMore: false
      };

    case actions.GENERATING_MERCHANT_SETTLEMENT_REPORT:
      return {
        ...state,
        generatedSettlementReportLoading: true,
        isError: false,
        pageLoading: true
      };

    case actions.GENERATE_MERCHANT_SETTLEMENT_REPORT_SUCCESS:
      return {
        ...state,
        isError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATE_MERCHANT_SETTLEMENT_REPORT_FAILED:
      return {
        ...state,
        generatedSettlementReportLoading: action.loading,
        isError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.FETCHING_SETTLEMENT_SUBMISSIONS:
      return {
        ...state,
        settlementSubmissionsLoading: action.loading
      };

    case actions.FETCH_SETTLEMENT_SUBMISSIONS_SUCCESS:
      return {
        ...state,
        settlementSubmissionsLoading: action.loading,
        settlementSubmissions: action.result,
        settlementSubmissionsIsError: false,
        settlementSubmissionsPagination: action.pagination,
        settlementSubmissionsLoadMore: false,
        settlementSubmissionsSummary: action.summary
      };

    case actions.FETCH_SETTLEMENT_SUBMISSIONS_FAILED:
      return {
        ...state,
        settlementSubmissionsLoading: action.loading,
        settlementSubmissionsIsError: true,
        settlementSubmissionsPagination: action.pagination,
        settlementSubmissionsLoadMore: false
      };

    case actions.FETCHING_SETTLEMENT_SUBMISSION:
      return {
        ...state,
        settlementSubmissionLoading: action.loading
      };

    case actions.FETCH_SETTLEMENT_SUBMISSION_SUCCESS:
      return {
        ...state,
        settlementSubmissionLoading: action.loading,
        settlementSubmission: action.result,
        settlementSubmissionIsError: false
      };

    case actions.FETCH_SETTLEMENT_SUBMISSION_FAILED:
      return {
        ...state,
        settlementSubmissionLoading: action.loading,
        settlementSubmissionIsError: true
      };

    case actions.DOWNLOADING_SETTLEMENT_SUBMISSION_DOCUMENT:
      return {
        ...state,
        downloadSettlementSubmissionDocumentLoading: true
      };

    case actions.DOWNLOAD_SETTLEMENT_SUBMISSION_DOCUMENT_SUCCESS:
      return {
        ...state,
        downloadSettlementSubmissionDocumentLoading: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_SETTLEMENT_SUBMISSION_DOCUMENT_FAILED:
      return {
        ...state,
        downloadSettlementSubmissionDocumentLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.APPROVING_SETTLEMENT_SUBMISSIONS:
    case actions.ENDORSING_SETTLEMENT_SUBMISSIONS:
    case actions.REJECTING_SETTLEMENT_SUBMISSIONS:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.APPROVE_SETTLEMENT_SUBMISSIONS_SUCCESS:
    case actions.ENDORSE_SETTLEMENT_SUBMISSIONS_SUCCESS:
    case actions.REJECT_SETTLEMENT_SUBMISSIONS_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.APPROVE_SETTLEMENT_SUBMISSIONS_FAILED:
    case actions.ENDORSE_SETTLEMENT_SUBMISSIONS_FAILED:
    case actions.REJECT_SETTLEMENT_SUBMISSIONS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: action.loading,
        isError: true
      };

    case actions.APPROVING_SETTLEMENT_SUBMISSION:
    case actions.ENDORSING_SETTLEMENT_SUBMISSION:
    case actions.REJECTING_SETTLEMENT_SUBMISSION:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.APPROVE_SETTLEMENT_SUBMISSION_SUCCESS:
    case actions.ENDORSE_SETTLEMENT_SUBMISSION_SUCCESS:
    case actions.REJECT_SETTLEMENT_SUBMISSION_SUCCESS:
      const updatedSettlementSubmissions =
        state.settlementSubmissions?.map(item => {
          if (item.id === action.payload.settlement_submission_id) {
            return action.result;
          }
          return item;
        }) || [];

      return {
        ...state,
        pageLoading: false,
        errorMessage: action.message,
        isError: false,
        settlementSubmissions: updatedSettlementSubmissions
      };

    case actions.APPROVE_SETTLEMENT_SUBMISSION_FAILED:
    case actions.ENDORSE_SETTLEMENT_SUBMISSION_FAILED:
    case actions.REJECT_SETTLEMENT_SUBMISSION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: action.loading,
        isError: true
      };

    case actions.GENERATING_CONSOLIDATED_SETTLEMENT_REPORT:
      return {
        ...state,
        consolidatedSettlementReportsLoading: true,
        consolidatedSettlementReportsIsError: false,
        pageLoading: true
      };

    case actions.GENERATE_CONSOLIDATED_SETTLEMENT_REPORT_SUCCESS:
      return {
        ...state,
        consolidatedSettlementReportsIsError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATE_CONSOLIDATED_SETTLEMENT_REPORT_FAILED:
      return {
        ...state,
        consolidatedSettlementReportsLoading: action.loading,
        consolidatedSettlementReportsIsError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.FETCHING_CONSOLIDATED_SETTLEMENT_REPORTS:
      return {
        ...state,
        consolidatedSettlementReports: null,
        consolidatedSettlementReportsLoading: action.loading
      };

    case actions.FETCH_CONSOLIDATED_SETTLEMENT_REPORTS_SUCCESS:
      return {
        ...state,
        consolidatedSettlementReportsLoading: action.loading,
        consolidatedSettlementReports: action.result,
        consolidatedSettlementReportsIsError: false,
        consolidatedSettlementReportsPagination: action.pagination
      };

    case actions.FETCH_CONSOLIDATED_SETTLEMENT_REPORTS_FAILED:
      return {
        ...state,
        consolidatedSettlementReportsLoading: action.loading,
        consolidatedSettlementReports: action.result,
        consolidatedSettlementReportsIsError: true,
        consolidatedSettlementReportsPagination: action.pagination
      };

    case actions.DOWNLOADING_CONSOLIDATED_SETTLEMENT_REPORT:
      return {
        ...state,
        downloadConsolidatedSettlementReportLoading: true
      };

    case actions.DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT_SUCCESS:
      return {
        ...state,
        downloadConsolidatedSettlementReportLoading: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT_FAILED:
      return {
        ...state,
        downloadConsolidatedSettlementReportLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.GENERATING_MERCHANT_SETTLEMENT_SUMMARY_REPORT:
      return {
        ...state,
        settlementSummaryReportLoading: true,
        settlementSummaryReportIsError: false,
        pageLoading: true
      };

    case actions.GENERATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        settlementSummaryReportIsError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED:
      return {
        ...state,
        settlementSummaryReportLoading: action.loading,
        settlementSummaryReportIsError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.DOWNLOADING_MERCHANT_SETTLEMENT_SUMMARY_REPORT:
      return {
        ...state,
        isDownloadingSettlementSummaryReportFile: true
      };

    case actions.DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        isDownloadingSettlementSummaryReportFile: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED:
      return {
        ...state,
        isDownloadingSettlementSummaryReportFile: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_MERCHANT_SETTLEMENT_SUMMARY_REPORTS:
      return {
        ...state,
        merchantSettlementSummaryReports: null,
        merchantSettlementSummaryReportsLoading: action.loading
      };

    case actions.FETCH_MERCHANT_SETTLEMENT_SUMMARY_REPORTS_SUCCESS:
      return {
        ...state,
        merchantSettlementSummaryReportsLoading: action.loading,
        merchantSettlementSummaryReports: action.result,
        merchantSettlementSummaryReportsIsError: false,
        merchantSettlementSummaryReportsPagination: action.pagination,
        merchantSettlementSummaryReportsFilter: action.filter
      };

    case actions.FETCH_MERCHANT_SETTLEMENT_SUMMARY_REPORTS_FAILED:
      return {
        ...state,
        merchantSettlementSummaryReportsLoading: action.loading,
        merchantSettlementSummaryReports: action.result,
        merchantSettlementSummaryReportsIsError: true,
        merchantSettlementSummaryReportsPagination: action.pagination
      };

    case actions.REQUESTING_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT:
    case actions.APPROVING_MERCHANT_SETTLEMENT_SUMMARY_REPORT:
    case actions.REJECTING_MERCHANT_SETTLEMENT_SUMMARY_REPORT:
      return {
        ...state,
        isError: false,
        merchantSettlementSummaryReportsLoading: true
      };

    case actions.REQUEST_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
    case actions.APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
    case actions.REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        merchantSettlementSummaryReportsLoading: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.REQUEST_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED:
    case actions.APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED:
    case actions.REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantSettlementSummaryReportsLoading: action.loading,
        isError: true
      };

    case actions.SENDING_EMAIL_VALIDATION_REPORT:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.SEND_EMAIL_VALIDATION_REPORT_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        settlementSubmissions:
          state.settlementSubmissions?.map(item => {
            if (item.id === action.payload.settlement_submission_id) {
              return { ...item, ...(action?.result ?? {}) };
            }
            return item;
          }) || []
      };

    case actions.SEND_EMAIL_VALIDATION_REPORT_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    default:
      return state;
  }
};
